import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import BlindReviewWorkbench from './BlindReviewWorkbench';
import { ErrorBoundary } from './components/ErrorBoundary';

axios.defaults.withCredentials = true;

// Global axios error interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.error || error?.message || '请求失败';
    console.error('API Error:', message, error?.config?.url);
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const RootSurface = window.location.pathname.replace(/\/$/, '') === '/blind-review'
  ? BlindReviewWorkbench
  : App;

if (window.location.protocol === 'http:' && window.location.hostname === 'looloothetoilet.duckdns.org') {
  window.location.replace(`https://looloothetoilet.duckdns.org:9443${window.location.pathname}${window.location.search}${window.location.hash}`);
} else {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <RootSurface />
      </ErrorBoundary>
    </React.StrictMode>
  );
}
